import { Component, OnInit } from '@angular/core';


import {  ProfileDataService } from '../../Services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
//import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { Page } from '../../Models/pages';
import { Role } from '../../Models/roles';

import {SelectItem, DataTableModule, ButtonModule, DialogModule, InputTextModule, MessagesModule, CalendarModule,Message, ConfirmationService} from 'primeng/primeng';

//import

@Component({
    //moduleId: module.id,
    templateUrl: './Roles.html'
})

export class RolesComponent implements OnInit {
    Label : string;
    Error: boolean;
    checked: boolean = false;
    displayDialog: boolean;
    dropdownlist: SelectItem[];
    role: PrimeRole = new PrimeRole();
    isNameTake: boolean;
    selectedTeamMemberProfile: PrimeRole;
    pages: Page[];
    newRole: boolean;
    EmailAvailability: boolean;
    roles: PrimeRole[];
    hdnLOVID: number;
    msgs: Message[] = [];
    PageIsvalid: boolean;
    userform: PrimeRole;
    IsDelete: boolean;
    IsSave: boolean;
    submitted: boolean;
    IsSubmitted: any; 
    a: number;
    constructor(private route: ActivatedRoute, private router: Router,private profiledataservice: ProfileDataService, private fb: FormBuilder, private confirmationService: ConfirmationService) {
        if (JSON.parse(window.localStorage.getItem('pagedetails')) != null) {
            this.pages = JSON.parse(window.localStorage.getItem('pagedetails'));
            if (router.url != '/home') {
                var isValid = false;
                for (var i = 0; i < this.pages.length; i++) {

                    if (this.pages[i].url == router.url) {


                        if (this.pages[i].permissionID == 1) {

                            this.IsDelete = false;
                            this.IsSave = false;
                        }
                        if (this.pages[i].permissionID == 2) {
                            this.IsDelete = false;
                            this.IsSave = true;
                        }
                        if (this.pages[i].permissionID == 3) {

                            this.IsDelete = true;
                            this.IsSave = true;
                        }

                    }


                }
            }

        }


    }

    ngOnInit() {
        this.PageIsvalid = true;
        this.isNameTake = true;
        this.userform = this.fb.group({
            'name': ["", Validators.required],
            'description': [""],
            'notes': [""]
        });
        //this.profiledataservice.GetTeamMembers(0).subscribe(profile => this.teamMemberProfile = profile);
        this.initialize();
    }

    initialize(){
        this.profiledataservice.GetRoles().subscribe((lstprofiles: Role[]) =>
            this.roles = lstprofiles
            

        );
        this.profiledataservice.GetPages().subscribe((list: Page[]) => {
           
            
            this.pages = list;
            this.dropdownlist = (this.TeamMemberListBind(JSON.stringify([{ name: 'Read Only', id: '1' }, { name: 'Read/Write', id: '2' }, { name: 'Read/Write/Delete', id: '3' }])));
        });
    }

	TeamMemberListBind(data: any) {
        var object = JSON.parse(data);
        for (var i = 0; i < object.length; i++) {
            if (object[i].hasOwnProperty("name")) {
                object[i]["label"] = object[i]["name"];
                delete object[i]["name"];
                object[i]["value"] = object[i]["id"];
                delete object[i]["id"];
            }
        }
        return object;
    }
    
    save() {


        if (this.newRole)
            this.roles.push(this.role);
        else
            this.roles[this.findSelectedLeaveTypeIndex()] = this.role;
        //alert('Dharam: Save Role Case');
        this.role = null;
        this.displayDialog = false;
    }

    delete() {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
        // this.userform = this.fb.group({
        //     'name': ["", Validators.required],
        //     'description': [""],
        //     'notes': [""]
        // });
        //console.log(1);
        this.profiledataservice.DeleteProfile(this.role);


        //this.leaveTypes.splice(this.findSelectedLeaveTypeIndex(), 1);
        //alert('Dharam: Delete Role Case');
        this.role = null;
        this.displayDialog = false;
            }
        });
    }
    cancel() {
        this.displayDialog = false;
    }
	RoleExist(role: any) {
        this.isNameTake = true;
        var roleList = this.roles;
       
        var name = role.name;
        var id = role.id;
        if (roleList != null && roleList.length > 0) {
            var filteredRoleList = roleList.filter(function (roleItem) {
                return roleItem.name == name && roleItem.id != id;
            });
            if (filteredRoleList != null && filteredRoleList.length > 0) {
                this.isNameTake = false;
                this.PageIsvalid = false;
                //return false;
            }
            else {
                this.isNameTake = true;
                this.PageIsvalid = true;
                
            }
         //   console.log('filteredRoleList: ', filteredRoleList);
        }

    }


    ShowAddEditDialog(isNew:boolean)
    {
        //this.userform.markAsPristine();
        // this.userform = this.fb.group({
        //     'name': ["", Validators.required],
        //     'description': [""],
        //     'notes': [""]
        // });
         //this.userform.markAsPristine();
         this.isNameTake = true;
        this.Label = "Edit Role";
        if (isNew) {
            this.Label = "Add Role";
            this.newRole = true;

            this.role = new PrimeRole();
            this.profiledataservice.GetPages().subscribe((list: Page[]) => {

                // console.log(list);
                this.pages = list;
                this.dropdownlist = (this.TeamMemberListBind(JSON.stringify([{ name: 'Read Only', id: '1' }, { name: 'Read/Write', id: '2' }, { name: 'Read/Write/Delete', id: '3' }])));
            });
        }
        else
        {
            this.profiledataservice.GetPagesByRoleID(this.role['id']).subscribe((list: Page[]) => {
                this.pages = list;
            });
        }
        this.hdnLOVID = 0;
        this.displayDialog = true;
    }

	edit(event: any, data: any) {
        

        this.role = data;
      
        
        this.ShowAddEditDialog(false);
        

        //this.profiledataservice.GetPagesByRoleID(data['id']).subscribe((list: Page[]) => {
        //        this.pages = list;
        //    });
        //this.displayDialog = true;
        
    }


	deleteRole(event: any, data: any) {
        this.confirmationService.confirm({
            message: ' Are you sure, you want to delete this record?',
            accept: () => {
        this.newRole = false;
       // console.log(data);

        //alert('Dharam: Delete Role Case');
        this.role = this.cloneLeaveType(data);
        this.role.active = false;
        this.profiledataservice.AddRole(this.role);
        //this.ngOnInit()
        this.initialize();
        this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Role deleted successfully !' });
        //console.log(this.role);
            }
        });
    }
	onRowSelect(event: any) {
        this.Label = "Edit Role";
        this.profiledataservice.GetPagesByRoleID(event.data['id']).subscribe((list: Page[]) => {
            this.pages = list;

        });
        this.hdnLOVID = event.data['id'];
        var email = event.data['email'];
        this.newRole = false;
        //console.log(event.data);
        //alert('Dharam: Select Role Case');
        this.role = this.cloneLeaveType(event.data);
        //console.log(this.role);
         //this.showDialogToAdd(this.role);
       
    }

    cloneLeaveType(c: Role): PrimeRole {
        let editrole = new PrimeRole();
        for (let prop in c) {
            editrole[prop] = c[prop];
        }
        return editrole;
    }

    findSelectedLeaveTypeIndex(): number {

        return this.roles.indexOf(this.selectedTeamMemberProfile);
    }
	updateChecked(page: any, event: any) {
       
         if (event.target.checked) {
            page.assigned = event.target.checked;
            page.roleID = this.role.id;
            this.Error = false;
        } else {
            page.assigned = false;
        }
        for (var i = 0; i < this.pages.length; i++) {
            if (this.pages[i].assigned) {
                //this.checked = true;
            }

        }


    }

    onSubmit(value: string) {
        if (this.PageIsvalid) {
            var role1 = this.role;
            this.Error = false;
            for (var i = 0; i < this.pages.length; i++) {


                if (this.pages[i].assigned) {
                    this.checked = true;

                }

            }
            //alert(1)
            if (this.checked == true) {
                if (this.newRole) {
                    this.profiledataservice.AddRole(this.role);
                    setTimeout(() => {

                        for (var i = 0; i < this.pages.length; i++) {

                            this.profiledataservice.AddPages(this.pages[i]);
                            if (i == this.pages.length - 1) {
                                //this.ngOnInit();
                                this.initialize();
                                //console.log(this.pages);
                                //window.location.href = '/#/userlist';
                                // this.user = null;

                            }

                        }
                    }, 1000);



                    this.roles.push(this.role);
                }
                else {
                    // this.profiledataservice.AddRole(this.role);
                    this.profiledataservice.AddRole(this.role);
                    setTimeout(() => {

                        for (var i = 0; i < this.pages.length; i++) {
                            // console.log("pages", role1);
                            this.pages[i].roleID = role1.id;
                            this.profiledataservice.AddPages(this.pages[i]);

                            if (i == this.pages.length - 1) {
                                //this.ngOnInit();
                                this.initialize();
                                //window.location.href = '/#/userlist';
                                // this.user = null;
                            }


                        }

                        this.roles[this.findSelectedLeaveTypeIndex()] = this.role;
                    }, 1000);
                }

                //alert('Dharam: On Submit Role Case');
                this.role = null;
                this.displayDialog = false;


                this.submitted = true;
                this.msgs = [];




                this.msgs.push({ severity: 'info', summary: 'Success', detail: 'Role saved successfully !' });
            } else {
                this.Error = true;
            }
        }
    }

}

class PrimePage implements Page {
	constructor(public id?: any, public name?: any, public assigned?: any, public userid?: any, public roleID?: any, public url?: any, public description?: any
		, public permissionID?: any
    ) { }
}

class PrimeRole implements Role {
	constructor(public id?: any, public name?: any, public description?: any, public notes?: any, public active?: any
    ) { }
}





// WEBPACK FOOTER //
// ./src/app/Components/Roles/Roles.ts